import {NavigationPathKey, TranslationKey} from '@enums'
import companiesCardImage from '@images/companies-card.jpg'
import dealersCardImage from '@images/dealers-card.jpg'
import parentCompaniesCardImage from '@images/parent-companies-card.jpg'
import usersCardImage from '@images/users-card.jpg'
import {Stack, useMediaQuery, useTheme} from '@mui/material'
import {pageLinksAtom} from '@state'

import {useEffect} from 'react'

import {TitleLink} from 'common/types'
import {useSetAtom} from 'jotai'
import {useTranslation} from 'react-i18next'

import {ComposedComponents} from '@components'

/**
 * Resources Dashboard page with navigation cards
 */
export function ResourcesDashboardPage() {
  const {t} = useTranslation()
  const setTitleLinks = useSetAtom(pageLinksAtom)
  const theme = useTheme()
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'))

  const titleLinks: TitleLink[] = [
    {title: t(TranslationKey['Admin panel']), link: NavigationPathKey.ADMIN_PANEL},
    {
      title: t(TranslationKey['Resources']),
    },
  ]

  useEffect(() => {
    setTitleLinks(titleLinks)
  }, [titleLinks])

  const navigationCardItems: ComposedComponents.CardItem[] = [
    {
      title: t(TranslationKey['Amplio partners']),
      key: NavigationPathKey.PARENT_COMPANY_SEARCH,
      image: parentCompaniesCardImage,
    },
    {
      title: t(TranslationKey.Companies),
      key: NavigationPathKey.COMPANY_SEARCH,
      image: companiesCardImage,
    },
    {
      title: t(TranslationKey.Dealers),
      key: NavigationPathKey.DEALER_SEARCH,
      image: dealersCardImage,
    },
    {
      title: t(TranslationKey.Users),
      key: NavigationPathKey.USER_SEARCH,
      image: usersCardImage,
    },
  ]

  return (
    <Stack gap={5}>
      <ComposedComponents.NavigationCards itemsInRow={isDownLg ? 1 : 2} items={navigationCardItems} />
    </Stack>
  )
}
